var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import RenderHtml from "./RenderHtml";
import { IMG_LOADING, URL_WP_AJAX } from '../constants/index';
class Loadmore {
    constructor(dataLoadmore) {
        this.states = {
            isProgressing: false,
            actionName: dataLoadmore.payload.action,
            paged: '2',
            slug: dataLoadmore.payload.slug,
            taxonomy: dataLoadmore.payload.taxonomy
        };
        this.dataLoadmore = dataLoadmore;
        this.queryStringParams = dataLoadmore.payload.params;
    }
    load() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            //if progressing, is return
            if (this.states.isProgressing === true) {
                return false;
            }
            let formData = new FormData();
            this.queryStringParams.forEach((item) => {
                formData.append(item.key, item.value);
            });
            formData.append('slug', this.states.slug);
            formData.append('taxonomy', this.states.taxonomy);
            formData.append('paged', this.states.paged);
            formData.append('action', this.states.actionName);
            //start fetch api
            (_a = this.dataLoadmore.btnLoadmore) === null || _a === void 0 ? void 0 : _a.insertAdjacentHTML('beforeend', ` <img id="img-loading" src="${IMG_LOADING}" />`);
            this.states.isProgressing = true;
            yield fetch(URL_WP_AJAX, {
                method: "POST",
                credentials: 'same-origin',
                body: formData
            })
                .then((response) => response.json())
                .then((data) => {
                var _a;
                this.states.isProgressing = false;
                if (parseInt(this.states.paged) >= data.response.data.maxNumPages) {
                    (_a = this.dataLoadmore.btnLoadmore) === null || _a === void 0 ? void 0 : _a.remove();
                }
                let paged = parseInt(this.states.paged);
                paged += 1;
                this.states.paged = paged.toString();
                const renderHtml = new RenderHtml(data, this.dataLoadmore);
                renderHtml.render();
                const iconLoading = document.getElementById('img-loading');
                iconLoading ? iconLoading.remove() : '';
            });
        });
    }
}
export default Loadmore;
